import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, TextInput, Keyboard, FlatList } from 'react-native';
import { oStyles } from './olonkho-styles';

export default function OButton({ title, onPress }) {
    return(
        <TouchableOpacity style={ [ oStyles.button_default, oStyles.button] } onPress={ onPress }>
            <Text style={ [ oStyles.button_default_text, oStyles.button_text ] }>{ title }</Text>
        </TouchableOpacity>
    );
}

export function OAnswerButton({ title, onPress }) {
    return(
        <TouchableOpacity style={ oStyles.answer_button } onPress={ onPress }>
            <Text style={ oStyles.answer_button_text }>{ title }</Text>
        </TouchableOpacity>
    );
}

export function OAboutButton({ title, onPress }) {
    return(
        <TouchableOpacity style={ oStyles.about_button } onPress={ onPress }>
            <Text style={ oStyles.about_button_text }>{ title }</Text>
        </TouchableOpacity>
    );
}

export function OSearchButton({ title, onPress }) {
    return(
        <TouchableOpacity style={ oStyles.advanced_search_button } onPress={ onPress }>
            <Text style={ oStyles.advanced_search_button_text }>{ title }</Text>
        </TouchableOpacity>
    );
}

export function OControlButton({ title, onPress }) {
    return (
        <TouchableOpacity style={ [ oStyles.button_default, oStyles.control_button ] } onPress={ onPress }>
            <Text style={ [ oStyles.button_default_text, oStyles.control_button_text ] }>{ title }</Text>
        </TouchableOpacity>
    );
}

export function OPanelButton({ title, onPress }) {
    return (
        <TouchableOpacity style={ [ oStyles.button_default, oStyles.panel_button] } onPress={ onPress }>
            <Text style={ [ oStyles.button_default_text, oStyles.panel_button_text ] }>{ title }</Text>
        </TouchableOpacity>
    );
}

export function OPageNumber({ number, onPress }) {
    return (
        <TouchableOpacity style={ oStyles.control_input } onPress={ onPress }>
            <Text style={ oStyles.control_input_text }>{ number }</Text>
        </TouchableOpacity>
    );
}

export function ODictItem({ item, navigation }) {
    return (
        <Text style={ oStyles.dictionary_item }>
            <Text style={ { fontStyle: 'italic' } }>{ item.text }</Text>
            <Text>{ " - " + item.translate + " " }</Text>
            <ODictLink lines={ item.lines } navigation={ navigation }/>
        </Text>
    );
}

export function ODictTableItem({ item }) {
    return (
        <View style={ { flexDirection: 'row' } }>
            <Text style={ {
                flex: 1,
                fontSize: 12,
                borderTopWidth: 0.5,
                borderBottomWidth: 0.5,
                borderLeftWidth: 1,
                textAlign: 'center'
            } }>{ item.lines.join(", ") }</Text>
            <Text style={ {
                flex: 2,
                fontSize: 12,
                borderTopWidth: 0.5,
                borderBottomWidth: 0.5,
                borderLeftWidth: 1,
                paddingLeft: 2
            } }>{ item.text }</Text>
            <Text style={ {
                flex: 2,
                fontSize: 12,
                borderTopWidth: 0.5,
                borderBottomWidth: 0.5,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                paddingLeft: 2
            } }>{ item.translate }</Text>
        </View>
    );
}

export function ODictLink({ lines, navigation }) {
    return (
        <FlatList 
            horizontal={ true }
            data={ lines }
            renderItem={ (line) => {
                let t = line.item.toString();
                if (line.index < lines.length - 1) {
                    t += ", ";
                }
                return <Text style={ oStyles.dictionary_link } onPress={ () => { 
                    navigation.navigate("Viewer", { line: line.item });
                } }>{ t }</Text>
            } }
            keyExtractor={ (line) => { return line } }
        />
    );
}

export function OTextInput( { isAnswer, answers, afterAnswer } ) {
    const correctAnswers = answers;
    const [inputValue, setInputValue] = useState("");
    Keyboard.addListener('keyboardDidHide', Keyboard.dismiss);

    function getIsCorrect() {
        for (var i = 0; i < correctAnswers.length; i++) {
            if (correctAnswers[i].toLowerCase() === inputValue.toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    useEffect(() => {
        if (isAnswer) {
            if (afterAnswer) {
                afterAnswer({ result: getIsCorrect() });
            }
        }
        else {
            setInputValue("");
        }
    }, [isAnswer]);

    return (
        <TextInput
            style={ [ oStyles.test_input, (isAnswer) ? 
                getIsCorrect() ? { borderColor: 'green', backgroundColor: 'lightgreen' } : { borderColor: 'red', backgroundColor: 'lightcoral' }
            : {} ]}
            onChangeText={ (text) => {
                setInputValue(text);
            } }
            value={ inputValue }
            editable={ !isAnswer }
        />
    );
}